import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressOverview = ({ overviewData }) => {
  const { totalCourses, completionPercentage, learningStreak, timeInvested } = overviewData;

  const stats = [
    {
      id: 1,
      label: 'Cursos Inscritos',
      value: totalCourses,
      icon: 'BookOpen',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      id: 2,
      label: 'Progresso Geral',
      value: `${completionPercentage}%`,
      icon: 'TrendingUp',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10'
    },
    {
      id: 3,
      label: 'Sequência de Aprendizado',
      value: `${learningStreak} dias`,
      icon: 'Flame',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      id: 4,
      label: 'Tempo Investido',
      value: timeInvested,
      icon: 'Clock',
      color: 'text-success',
      bgColor: 'bg-success/10'
    }
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-6 mb-8">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-heading font-semibold text-foreground">
            Visão Geral do Progresso
          </h2>
          <p className="text-muted-foreground font-caption mt-1">
            Acompanhe seu desenvolvimento educacional
          </p>
        </div>
        <div className="hidden md:flex items-center space-x-2">
          <Icon name="Calendar" size={16} className="text-muted-foreground" />
          <span className="text-sm text-muted-foreground font-caption">
            Atualizado hoje
          </span>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats?.map((stat) => (
          <div key={stat?.id} className="relative">
            <div className="flex items-center space-x-4 p-4 rounded-lg bg-background border border-border hover:shadow-tier-1 transition-micro">
              <div className={`w-12 h-12 rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
                <Icon name={stat?.icon} size={24} className={stat?.color} />
              </div>
              <div className="flex-1">
                <p className="text-2xl font-heading font-semibold text-foreground">
                  {stat?.value}
                </p>
                <p className="text-sm text-muted-foreground font-caption">
                  {stat?.label}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* Progress Ring */}
      <div className="mt-8 flex items-center justify-center">
        <div className="relative w-32 h-32">
          <svg className="w-32 h-32 transform -rotate-90" viewBox="0 0 120 120">
            <circle
              cx="60"
              cy="60"
              r="50"
              stroke="var(--color-muted)"
              strokeWidth="8"
              fill="none"
              opacity="0.3"
            />
            <circle
              cx="60"
              cy="60"
              r="50"
              stroke="url(#progressGradient)"
              strokeWidth="8"
              fill="none"
              strokeLinecap="round"
              strokeDasharray={`${(completionPercentage / 100) * 314} 314`}
              className="transition-all duration-1000 ease-out"
            />
            <defs>
              <linearGradient id="progressGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="var(--color-secondary)" />
                <stop offset="100%" stopColor="var(--color-primary)" />
              </linearGradient>
            </defs>
          </svg>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center">
              <p className="text-2xl font-heading font-bold text-foreground">
                {completionPercentage}%
              </p>
              <p className="text-xs text-muted-foreground font-caption">
                Concluído
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressOverview;